"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderCustomize = void 0;
var react_1 = __importDefault(require("react"));
var Section_1 = require("../components/Section");
var variables = "$border: (\n  n: 3, // maximum border-width (.bdr3)\n  rnd: 4px, // border-radius of .rnd\n);";
var BorderCustomize = function () { return (react_1.default.createElement(Section_1.Customize, { variables: variables })); };
exports.BorderCustomize = BorderCustomize;
